/**
 * @generated SignedSource<<c81f710e8322886580494404ddc0ba03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreProductDetailPageQuery$variables = {
  productId: string;
};
export type StoreProductDetailPageQuery$data = {
  readonly product: {
    readonly " $fragmentSpreads": FragmentRefs<"StorePackageDetailFooter_package" | "StorePackageDetail_package" | "usePackageDisplayName_package">;
  } | null | undefined;
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly club: {
          readonly id: string;
          readonly logoImage: {
            readonly publicId: string;
          } | null | undefined;
          readonly name: string;
          readonly slug: string;
          readonly supportsPublic: boolean;
        };
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"StorePackageDetailFooter_session">;
  } | null | undefined;
};
export type StoreProductDetailPageQuery = {
  response: StoreProductDetailPageQuery$data;
  variables: StoreProductDetailPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Club",
  "kind": "LinkedField",
  "name": "club",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPublic",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "type",
  "value": "MEMBERSHIP"
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreProductDetailPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StorePackageDetailFooter_session"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "product",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "usePackageDisplayName_package"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StorePackageDetail_package"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StorePackageDetailFooter_package"
              }
            ],
            "type": "Package",
            "abstractKey": "__isPackage"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoreProductDetailPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "ACTIVE"
                          },
                          (v6/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": "memberPackages(status:\"ACTIVE\",type:\"MEMBERSHIP\")"
                      },
                      {
                        "alias": "upcomingMemberPackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "UPCOMING"
                          },
                          (v6/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": "memberPackages(status:\"UPCOMING\",type:\"MEMBERSHIP\")"
                      }
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v8/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "product",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DisplayInApp",
                "kind": "LinkedField",
                "name": "displayInApp",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BenefitsSummaryLine",
                "kind": "LinkedField",
                "name": "benefitsSummary",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "activeUntilPeriod",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "activeUntilPeriodUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "activeUntilPeriodType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingOption",
                "kind": "LinkedField",
                "name": "billingOptions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingCharge",
                    "kind": "LinkedField",
                    "name": "billingCharges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "frequency",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareItemVariation",
                        "kind": "LinkedField",
                        "name": "squareVariation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "amount",
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minimumCommitmentMonths",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Package",
            "abstractKey": "__isPackage"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51eaf89ddce409d00de52d47a9518063",
    "id": null,
    "metadata": {},
    "name": "StoreProductDetailPageQuery",
    "operationKind": "query",
    "text": "query StoreProductDetailPageQuery(\n  $productId: ID!\n) {\n  session {\n    ...StorePackageDetailFooter_session\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        club {\n          id\n          slug\n          name\n          supportsPublic\n          logoImage {\n            publicId: renderingKey\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  product: node(id: $productId) {\n    __typename\n    ... on Package {\n      __isPackage: __typename\n      ...usePackageDisplayName_package\n      ...StorePackageDetail_package\n      ...StorePackageDetailFooter_package\n    }\n    id\n  }\n}\n\nfragment PackageBenefitsSummary_package on Package {\n  __isPackage: __typename\n  benefitsSummary {\n    description\n  }\n}\n\nfragment StorePackageDetailFooter_package on Package {\n  __isPackage: __typename\n  id\n  __typename\n  ...usePackageDisplayName_package\n}\n\nfragment StorePackageDetailFooter_session on Session {\n  ...useIsUserSignedIn_session\n  ...useCustomerHasActiveOrUpcomingMembership_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment StorePackageDetail_package on Package {\n  __isPackage: __typename\n  ...PackageBenefitsSummary_package\n  ...StorePackageSummary_package\n  id\n}\n\nfragment StorePackageSummary_package on Package {\n  __isPackage: __typename\n  id\n  __typename\n  billingType\n  startOn\n  endOn\n  activeUntilPeriod\n  activeUntilPeriodUnit\n  activeUntilPeriodType\n  ...useGetPackagePriceMap_package\n  ...useGetMinimumCommitment_package\n}\n\nfragment useCustomerHasActiveOrUpcomingMembership_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n        memberPackages(status: ACTIVE, type: MEMBERSHIP) {\n          count\n        }\n        upcomingMemberPackages: memberPackages(status: UPCOMING, type: MEMBERSHIP) {\n          count\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGetMinimumCommitment_package on Package {\n  __isPackage: __typename\n  id\n  billingOptions {\n    minimumCommitmentMonths\n  }\n}\n\nfragment useGetPackagePriceMap_package on Package {\n  __isPackage: __typename\n  billingOptions {\n    billingCharges {\n      frequency\n      squareVariation {\n        amount\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment useIsUserSignedIn_session on Session {\n  user {\n    __typename\n    id\n  }\n}\n\nfragment usePackageDisplayName_package on Package {\n  __isPackage: __typename\n  displayInApp {\n    displayName\n  }\n  name\n}\n"
  }
};
})();

(node as any).hash = "7a91a0a8c4d4991fac9a13cd394d1df7";

export default node;
